import React, {useState, useMemo, useEffect} from 'react';
import CheckboxWithText from '../GenericFormActions/SubComponents/CheckboxWithText/CheckboxWithText';
import DescriptiveLink from '../GenericFormActions/SubComponents/DescriptiveLink/DescriptiveLink';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import AlertContentHeader from './SubComponents/AlertContentHeader/AlertContentHeader';
import {isValidObject} from '../../../Assets/functions/functions';
import {connect} from 'react-redux';
import {setPopupCloseBtnClicked} from '../../../BusinessClientEsimUpgradeSlice';

const AlertBox = ({
  headerObj = {},
  underlineTextObj = {},
  isCheckedRequired = false,
  aboveBtnError = '',
  btnText = '',
  btnCallback = null,
  popupCloseBtnCallback = null,
  isPopupCloseBtnClicked,
  setPopupCloseBtnClicked,
}) => {

  useEffect(() => {
    if (isPopupCloseBtnClicked) {
      if (popupCloseBtnCallback) {
        popupCloseBtnCallback();
      }
      setPopupCloseBtnClicked(false);
    }
  }, [isPopupCloseBtnClicked]);

  const [isChecked, setIsChecked] = useState(false);
  const [showAboveBtnError, setShowAboveBtnError] = useState(false);

  const enhancedHeaderObj = useMemo(() => {
    if (!headerObj?.checkboxObj) return headerObj;

    return {
      ...headerObj,
      checkboxObj: {
        ...headerObj.checkboxObj,
        callback: setIsChecked,
      },
    };
  }, [headerObj, isChecked]);

  useEffect(() => {
    if (isChecked && showAboveBtnError) {
      setShowAboveBtnError(false);
    }
  }, [isChecked, showAboveBtnError]);

  function handleBtnClick() {
    if (isCheckedRequired && aboveBtnError && !isChecked) {
      if (!showAboveBtnError) {
        setShowAboveBtnError(true);
      }
      return;
    }
    if (btnCallback) {
      btnCallback();
    }
  }

  return (
    <div className='alert-box'>
      <AlertContentHeader {...enhancedHeaderObj} />

      {isValidObject(underlineTextObj) && <DescriptiveLink {...underlineTextObj} />}

      {btnText && (
        <div className='alert-btn-container'>
          {aboveBtnError && showAboveBtnError && <span className='error-message'>{aboveBtnError}</span>}
          <BtnSubmit text={btnText} onclick={handleBtnClick} />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isPopupCloseBtnClicked: state.BusinessClientEsimUpgradeSlice?.isPopupCloseBtnClicked,
  };
};

const mapDispatchToProps = {
  setPopupCloseBtnClicked,
};
export default connect(mapStateToProps, mapDispatchToProps)(AlertBox);
